<template>
  <div
    style="
      overflow: hidden;
      height: 100%;
      background-color: #f6f6f6;
      padding: 10px;
      display: flex;
      flex-direction: column;
    "
  >
    <ul
      style="
        display: flex;
        padding: 0 10px 10px 10px;
        align-items: center;
        line-height: 30px;
      "
    >
      <van-checkbox
        v-model="state.selectAll"
        name="c"
        shape="square"
        :icon-size="18"
        @change="onSelectAll"
      >
        全选
      </van-checkbox>
      <span
        style="
          flex: 1;
          margin-left: 10px;
          color: #a2a2a2;
          font-size: 90%;
          overflow-x: auto;
        "
      >
        <template v-if="state.selectRows?.length > 0">
          已选
          <strong style="color: #1e90ff">{{ state.selectRows?.length }}</strong>
          项,总金额为 <strong style="color: #f00">{{ state.total }}</strong>
        </template>
      </span>
      <van-button
        type="primary"
        size="small"
        @click="state.showCheck = true"
        :disabled="!state.selectRows?.length > 0"
      >
        批量审批
      </van-button>
    </ul>
    <div style="flex: 1; overflow-y: auto">
      <van-pull-refresh v-model="state.isRefresh" @refresh="onRefresh">
        <van-list
          v-model:loading="state.loading"
          v-model:error="state.error"
          :error-text="state.errorMsg"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-checkbox-group
            v-model="state.selectRows"
            shape="square"
            :icon-size="18"
            ref="checkedGroupDom"
            @change="onSelectChange"
          >
            <div
              v-for="item in state.listData"
              :key="item"
              style="
                background-color: #fff;
                border-radius: 10px;
                padding: 10px;
                position: relative;
                font-size: 13px;
                margin-bottom: 10px;
              "
              @click="toDetail(item)"
            >
              <ul
                style="
                  display: flex;
                  align-items: center;
                  padding-bottom: 10px;
                  border-bottom: 1px solid #e2e2e2;
                "
              >
                <van-checkbox :name="item" @click.stop=""></van-checkbox>
                <li
                  style="
                    flex: 1;
                    font-weight: 600;
                    font-size: 14px;
                    margin-left: 5px;
                  "
                >
                  {{ item.customer_name }}
                </li>
                <template v-if="[1, 2].includes(item.status)">
                  <van-tag type="danger" v-if="item.is_arrearage">欠款</van-tag>
                  <c_status
                    arrName="salaryapply_status"
                    :value="item.status"
                    :leftSize="5"
                  />
                </template>
                <template v-else>
                  <template v-if="item.step == 2">
                    <van-tag type="danger" v-if="item.is_arrearage"
                      >欠款</van-tag
                    >
                    <c_status
                      arrName="salaryapply_step"
                      value="2-1"
                      :leftSize="5"
                      v-if="item.is_arrearage"
                    />
                    <c_status
                      arrName="salaryapply_step"
                      value="2-2"
                      :leftSize="5"
                      v-else
                    />
                  </template>
                  <c_status
                    v-else
                    arrName="salaryapply_step"
                    :value="item.step"
                    :leftSize="5"
                  />
                </template>
              </ul>
              <ul style="margin-top: 10px">
                {{
                  item.name
                }}
              </ul>
              <ul style="display: flex; align-items: center; line-height: 30px">
                <text style="color: #a2a2a2">发放人数：</text>
                {{
                  item.employee_num
                }}
              </ul>
              <ul style="display: flex; align-items: center; line-height: 30px">
                <text style="color: #a2a2a2">申请人：</text>
                {{
                  item.add_admin_name
                }}
                <text v-if="item.add_department_name">{{
                  "/" + item.add_department_name
                }}</text>
              </ul>
              <ul style="display: flex; align-items: center; line-height: 30px">
                <text style="color: #a2a2a2">申请时间：</text>
                {{
                  item.create_time
                }}
              </ul>
              <ul style="display: flex; align-items: center; line-height: 30px">
                <text style="color: #a2a2a2">薪资所属期：</text>
                {{
                  item.month
                }}
              </ul>
              <ul style="display: flex; align-items: center; line-height: 30px">
                <text style="color: #a2a2a2">约定发薪日期：</text>
                {{
                  item.pay_date
                }}
              </ul>
              <div
                style="
                  position: absolute;
                  right: 10px;
                  bottom: 10px;
                  box-shadow: 0 0 3px 1px #e2e2e2;
                  padding: 20px;
                  background-color: #fff;
                  border-radius: 5px;
                "
              >
                <ul style="text-align: center; font-size: 16px">
                  <c_money :value="item.money" bold />
                </ul>
                <ul style="text-align: center; color: #a2a2a2; font-size: 10px">
                  发放金额
                </ul>
              </div>
            </div>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup
      v-model:show="state.showDetail"
      position="right"
      teleport="body"
      style="width: 100%; height: 100%"
    >
      <c_Check
        v-if="state.showDetail"
        :id="state.selectItem?.id"
        @close="onCheckClose"
      ></c_Check>
    </van-popup>
    <van-popup
      v-model:show="state.showCheck"
      position="center"
      style="width: 90%; padding: 20px; background: #f6f6f6"
      round
    >
      <ul style="text-align: center; font-weight: 600">
        批量审批
      </ul>
      <ul
        style="
          text-align: center;
          font-size: 90%;
          color: #a2a2a2;
          margin-top: 5px;
        "
      >
        当前已选
        <strong style="color: #1e90ff">{{ state.selectRows?.length }}</strong>
        项,总金额为<strong style="color: #f00">{{ state.total }}</strong>
      </ul>
      <van-form
        @submit="onSubmit"
        label-align="top"
        style="
          margin-top: 10px;
          border-radius: 10px;
          --van-field-label-color: #525253;
        "
      >
        <van-field
          name="checkboxGroup"
          label="状态"
          required
          :rules="[{ required: true, message: '请选择审批状态' }]"
        >
          <template #input>
            <van-radio-group v-model="state.status" direction="horizontal">
              <van-radio
                :name="1"
                style="--van-radio-checked-icon-color: #1e90ff"
              >
                审批通过
              </van-radio>
              <van-radio :name="2" style="--van-radio-checked-icon-color: #f00">
                审批不通过
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="state.msg"
          rows="1"
          autosize
          label="审批意见"
          type="textarea"
          placeholder="请输入留言"
          :required="state.status == 2"
          :rules="[{ required: state.status == 2, message: '请填写审批意见' }]"
        />
        <div
          style="
            display: grid;
            column-gap: 10px;
            margin-top: 10px;
            grid-template-columns: 20% 1fr;
          "
        >
          <van-button @click="delete state.showCheck">取消</van-button>
          <van-button block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { check_list, check } from "@/http/api";
import constant from "@/utils/constant";
import c_Check from "./Check.vue";
import { Decimal } from "decimal.js";
import { showConfirmDialog, showNotify } from "vant";
export default {
  components: {
    c_Check,
  },
  setup() {
    const checkedGroupDom = ref(null);
    const state = reactive({
      params: {
        limit: 200,
        page: 0,
        sort_value: "desc",
      },
      listData: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      state.loading = true;
      state.params.page++;

      check_list(state.params)
        .then((res) => {
          state.loading = false;
          state.isRefresh = false;
          if (res.status == 200) {
            const list = res.data.data?.list;
            state.listData = [...(state.listData || []), ...list];

            if (list.length < constant.pageSize) {
              state.finished = true;
            }
          }
        })
        .catch((err) => {
          state.error = true;
          state.errorMsg = err;
          state.loading = false;
          state.isRefresh = false;
        });
    };

    const onRefresh = () => {
      state.isRefresh = true;
      state.params.page = 0;
      state.listData = [];
      state.finished = false;
      onLoad();
    };

    const toDetail = (item) => {
      state.selectItem = item;
      state.showDetail = true;
    };

    const onCheckClose = (isRef) => {
      state.showDetail = false;
      if (isRef) onRefresh();
    };

    const onSelectAll = (checked) => {
      checkedGroupDom.value.toggleAll(checked);
    };
    const onSelectChange = (data) => {
      state.total = data.reduce((acc, cur) => {
        return acc.plus(new Decimal(cur.money.toString()));
      }, new Decimal("0"));
    };

    const onSubmit = () => {
      let msg = "";
      if (state.status == 1) {
        msg = `您确定<strong style='color:#080'>同意</strong>已选<strong style='color:#1e90ff'>${state.selectRows?.length}</strong>项的发薪申请吗?`;
      } else if (state.status == 2) {
        msg = `您确定<strong style='color:#f00'>拒绝</strong>已选<strong style='color:#1e90ff'>${state.selectRows?.length}</strong>项的发薪申请吗?`;
      }

      if (msg) {
        showConfirmDialog({
          title: "批量发薪审批",
          message: msg,
          allowHtml: true,
        }).then(() => {
          const data = {
            id: state.selectRows?.map((m) => m.id).join(","),
            status: state.status,
            msg: state.msg,
          };

          check(data).then((res) => {
            if (res.status == 200) {
              delete state.showCheck;
              showNotify({ type: "success", message: res.data.data?.msg });
              onRefresh();
            }
          });
        });
      }
    };

    return {
      state,
      toDetail,
      onLoad,
      onRefresh,
      onCheckClose,
      checkedGroupDom,
      onSelectAll,
      onSelectChange,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
